// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "groupfolders-" + chunkId + ".js?v=" + {"vendors-node_modules_nextcloud_axios_dist_index_esm_js-node_modules_nextcloud_vue_dist_Compon-cb985d":"7116cb53696b353ff754","sharing":"f3d6d8e6f29a156e860a"}[chunkId] + "";
};